import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=8c8cf1bc&scoped=true&"
import script from "./Profiles.vue?vue&type=script&lang=js&"
export * from "./Profiles.vue?vue&type=script&lang=js&"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=8c8cf1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8cf1bc",
  null
  
)

component.options.__file = "Profiles.vue"
export default component.exports